import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { createStackNavigator } from "@react-navigation/stack";
import { MailStackParamList } from "../types";
import { Platform, View } from "react-native";
import styles from "../../../stylesheet";

import React from 'react';
import MailLoginScreen from "../screens/MidLevel/MailScreen/MailLoginScreen";
import MailScreen from "../screens/MidLevel/MailScreen/MailScreen";
import IndividualMailScreen from "../screens/MidLevel/MailScreen/IndividualMailScreen";
import { themeSelector } from "@reduxLocal/selectors/themeSelector";

const MailStack = Platform.select({ default: createNativeStackNavigator<MailStackParamList>(), web: createStackNavigator<MailStackParamList>() })

const MailNavigator = () => {
  const theme = themeSelector();
  return (
    <View style={{ flex: 1, flexDirection: 'row' }}>
      <View style={styles.appContainer}>
        <View style={{ flex: 3, paddingBottom: 1, borderRadius: 20 }}>
          <MailStack.Navigator
            screenOptions={{ headerShown: false, cardStyle: {
              backgroundColor: theme ? "white" : "black"
            } }}
            initialRouteName="Mail"
          >
            <MailStack.Screen
              name="MailLoginScreen"
              component={MailLoginScreen}
              options={{ headerTitle: 'LoginScreen' }} />
            <MailStack.Screen
              name="Main"
              component={MailScreen}
               />
            <MailStack.Screen
              name="IndividualMailScreen"
              component={IndividualMailScreen}
              options={{ headerTitle: 'Main' }} />
          </MailStack.Navigator>
        </View>
      </View>
    </View>
  )
}

export { MailStack, MailNavigator };
